export default __webpack_public_path__ + "static/media/protfolio_banner.392addb6.png";